import { WcDatepicker } from './wc-datepicker';
import './index.scss';

customElements.define('wc-datepicker', WcDatepicker);